module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer/footer.component.html
// module id = ./src/app/layout/footer/footer.component.html
// module chunks = main